// Carnival year configuration
// Change VITE_CARNIVAL_YEAR environment variable to update the current year

export const CURRENT_CARNIVAL_YEAR = parseInt(
  import.meta.env.VITE_CARNIVAL_YEAR || '2026'
);

// Years available for analytics viewing
export const SUPPORTED_YEARS = [2024, 2025, 2026] as const;
export type CarnivalYear = (typeof SUPPORTED_YEARS)[number];

// Helper to check if a year is supported
export function isSupportedYear(year: number): year is CarnivalYear {
  return SUPPORTED_YEARS.includes(year as CarnivalYear);
}
